// extracted by mini-css-extract-plugin
export default {"container":"ContentArea_container__n5QhS","noMargin":"ContentArea_noMargin__He+tx"};